import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Usuario } from "@/shared/types/usuario";

export interface UsuarioEditRequest {
    nombre?: string,
    email?: string,
    numDocumento?: string,
    organizacionId?: string,
    telefono?: string,
    direccion?: string,
}

export async function editUsuario(id: string, request: UsuarioEditRequest): Promise<Usuario> {
    await sleep(1000);
    const response = await api.put("usuarios/" + id, request);
    return response.data;
}

export function useEditUsuarioMutation(id: string, mutationConfig: MutationConfig<Usuario, UsuarioEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: UsuarioEditRequest) => await editUsuario(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["usuarios"] });
        },
    })
}

export interface EditUsuarioMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Usuario, UsuarioEditRequest>,
    children?: (mutationResult: MutationResult<Usuario, UsuarioEditRequest>) => ReactNode
}

export function EditUsuarioMutation({
    id,
    children,
    mutationConfig
}: EditUsuarioMutationProps) {
    const mutationResult = useEditUsuarioMutation(id, mutationConfig);
    return children && children(mutationResult)
}